
import servicesMixin from '~/mixins/services';

export default {
    name: 'QuoteFormService',
    mixins: [servicesMixin],
    props: {
        /**
         * The services form field
         */
        field: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * Allow selecting multiple items?
         */
        multiple: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [Array, Number],
            required: true,
        },
    },
    data() {
        return {
            selected: this.value,
        };
    },
    computed: {
        showDescriptions() {
            return this.$route.name.indexOf('business') === -1;
        },
    },
    watch: {
        selected(value) {
            this.$emit('input', value);
        },
    },
};
